import React from 'react';
import Modal from 'components/common/Modal';
import { LoadingSpinner } from 'components/common';

const ModalGerandoPdf = ({ isOpen }) => {
  return (
    <Modal isOpen={isOpen} onClose={() => {}} title="Gerando PDF" size="md" headerBorder={false}>
      <div className="py-4">
        <LoadingSpinner
          fullScreen={false}
          className="min-h-[120px] w-full"
          cardClassName="w-full"
          flat
          label="Gerando relatório em PDF"
          subtitle="Aguarde enquanto preparamos a pré-visualização."
        />
      </div>
    </Modal>
  );
};

export default ModalGerandoPdf;
